let md5 = require('md5');
export class UidGenerate {

    static gen(): string{
        return md5('UID-'+Date());
    }
}
